import styled from 'styled-components'

export const TopBarDropDownIconWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  > div {
    margin-left: 24px;
    cursor: pointer;
    user-select: none;
  }
`

export const TopBarDropdownMenuWrapper = styled.div`
  display: ${(p) => {
    return p.open ? 'block' : 'none'
  }};
  height: 192px;  
  border-radius: 8px;
  background: white;
  border: 1px solid rgba(32, 32, 32, 0.1);
  position: absolute;
  top: 88px;
  right: 56px;
  padding: 8px 0;
  text-align: left;
  z-index: 1000;
`

export const TopBarDropdownItem = styled.div`
  height: 40px;
  width: 100%;
  padding-right: 32px;
  background: white;
  padding-left: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  
  background: ${(p) => {
    return p.active ? 'rgba(32, 32, 32, 0.05)' : 'rgba(255, 255, 255, 1)'
  }};

  > svg {
    margin-right: 16px;
  }

  :hover {  
    background: rgba(32, 32, 32, 0.05);    
  }  
`

export const TopBarDropdownSignOutWrapper = styled.div`
  height: 48px;
  margin-top: 8px;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: flex-end;
`
